import { useState } from "react";
import MessagesCard from "../../common/components/messages/MessagesCard";
// import NotificationsCard from "../../common/components/NotificationsCard";
import { MessageInbox } from "../../common/components/MessageInbox";
import { NotificationCenter } from "../../common/components/NotificationCenter";

type ViewMode = "popups" | "fullpage";

export function MessagingPage() {
  const [viewMode, setViewMode] = useState<ViewMode>("popups");

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Messages & Notifications
        </h1>
        <p className="text-gray-600">
          Unified messaging and notification system for MedEx
        </p>
      </div>

      {/* Toggle View Mode */}
      <div className="mb-8 flex gap-4">
        <button
          onClick={() => setViewMode("popups")}
          className={`px-6 py-2 rounded-lg font-medium transition ${
            viewMode === "popups"
              ? "bg-indigo-600 text-white"
              : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
          }`}
        >
          Popup View
        </button>
        <button
          onClick={() => setViewMode("fullpage")}
          className={`px-6 py-2 rounded-lg font-medium transition ${
            viewMode === "fullpage"
              ? "bg-indigo-600 text-white"
              : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
          }`}
        >
          Full Page View
        </button>
      </div>

      {/* Popup View */}
      {viewMode === "popups" && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="flex justify-center">
            <MessagesCard />
          </div>
          <div className="flex justify-center">
            {/* <NotificationsCard /> */}
          </div>
        </div>
      )}

      {/* Full Page View */}
      {viewMode === "fullpage" && (
        <div className="space-y-8">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Message Inbox
            </h2>
            <MessageInbox />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Notification Center
            </h2>
            <NotificationCenter />
          </div>
        </div>
      )}
    </div>
  );
}
